/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.27/esri/copyright.txt for details.
*/
const e={orderedRepackingEnabled:!1},n={rootOrigin:null};export{n as gridLocalOriginFactory,e as textTextureAtlas};
